import { COLOR } from "../utils/theme";

export default function OrbitLoader() {
  return (
    <div style={{
      position: "relative", width: 96, height: 96,
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      {/* Center diamond */}
      <span style={{
        fontSize: 28, color: COLOR.mauve,
        animation: "centerPulse 2s ease-in-out infinite",
      }}>{"✦"}</span>

      {/* Three orbiting diamonds */}
      {[0, 1, 2].map(i => (
        <span
          key={i}
          style={{
            position: "absolute",
            top: "50%", left: "50%",
            marginTop: -7, marginLeft: -7,
            fontSize: 14, color: COLOR.mauve,
            animation: `orbit 3.2s linear infinite`,
            animationDelay: `${i * (3.2 / 3)}s`,
          }}
        >{"✦"}</span>
      ))}
    </div>
  );
}
